import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';
import { useState } from 'react';

interface RenameCaseModalProps {
  open: boolean;
  onClose: () => void;
  currentCaseName: string;
  onRename: (newName: string) => void;
  loading: boolean;
}

function RenameCaseModal({ open, onClose, currentCaseName, onRename, loading }: RenameCaseModalProps) {
  const [newName, setNewName] = useState(currentCaseName);

  const handleRenameClick = () => {
    if (newName.trim() !== '' && newName !== currentCaseName) {
      onRename(newName.trim());
    }
  };

  const handleModalClose = () => {
    setNewName(currentCaseName);
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth='xs'
      slotProps={{
        paper: {
          component: 'form',
          onSubmit: (e: React.FormEvent) => {
            e.preventDefault();
            handleRenameClick();
          },
        },
      }}
    >
      <DialogTitle>Rename</DialogTitle>
      <DialogContent>
        <TextField
          margin='dense'
          label='Case name'
          type='text'
          fullWidth
          variant='standard'
          value={newName}
          onChange={(e) => setNewName(e.target.value)}
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={handleModalClose} disabled={loading} sx={{ color: '#000' }}>
          Cancel
        </Button>

        <Button
          type='submit'
          onClick={handleRenameClick}
          disabled={loading || newName.trim() === '' || newName === currentCaseName}
          disableElevation
          variant='contained'
        >
          {loading ? 'Please wait...' : 'Rename'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default RenameCaseModal;
